import { Dashboard } from "./dashboard.model";
import { Review } from "./review.model";

export class DashboardReviewData {

    private dashboards: Array<Dashboard>;
    private reviews: Array<Review>;

    constructor(raw: any) {
        if (raw) {
            this.setDashboards((raw.DASHBOARD || []).map((dashboard: any) => new Dashboard(dashboard)));
            this.setReviews((raw.REVIEWS || []).map((review: any) => new Review(review)));

            this.dashboards.sort((dashboard, otherDashboard) => (dashboard.getProductGroupOrder() || 0) - (otherDashboard.getProductGroupOrder() || 0));
        }
    }

    public getDashboards(): Array<Dashboard> {
        return this.dashboards;
    }

    public setDashboards(dashboards: Array<Dashboard>): void {
        this.dashboards = dashboards;
    }

    public getReviews(): Array<Review> {
        return this.reviews;
    }

    public setReviews(reviews: Array<Review>): void {
        this.reviews = reviews;
    }

}